import { shape } from 'prop-types';
import { SectionItem } from '~/components';

export const PhoneSection = ({ store }) => (
  <SectionItem title="Beauty Society phone number" definition={store.phoneNumber} />
);

PhoneSection.propTypes = {
  store: shape({}).isRequired,
};
